import { FC, HTMLAttributes } from 'react';

export const ReactComponent: FC<HTMLAttributes<SVGElement>> = (props) => (
  <svg
    {...props}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 16C17 16.5523 16.5523 17 16 17H4C3.44772 17 3 16.5523 3 16V7H17V16ZM12.8525 9.14746C12.6557 8.95087 12.3365 8.951 12.1396 9.14746L10 11.2871L7.86035 9.14746C7.66342 8.95106 7.3442 8.95075 7.14746 9.14746C6.9507 9.34434 6.95071 9.66445 7.14746 9.86133L9.28613 12L7.14746 14.1396C6.95113 14.3365 6.95091 14.6558 7.14746 14.8525C7.34433 15.0494 7.66441 15.0493 7.86133 14.8525L10 12.7139L12.1387 14.8525C12.3355 15.0494 12.6556 15.0493 12.8525 14.8525C13.0493 14.6558 13.049 14.3366 12.8525 14.1396L10.7129 12L12.8525 9.86133C13.0494 9.66442 13.0494 9.34437 12.8525 9.14746ZM14 2C14.5523 2 15 2.44772 15 3H16C16.5523 3 17 3.44772 17 4V6H3V4C3 3.44772 3.44772 3 4 3H5C5 2.44772 5.44772 2 6 2C6.55228 2 7 2.44772 7 3H13C13 2.44772 13.4477 2 14 2Z"
      fill="#B3BBCB"
    />
  </svg>
);
